module.exports = __webpack_public_path__ + "static/img/xg1-1.d6e06bd.png";


//////////////////
// WEBPACK FOOTER
// ./static/workoff/excelimg/xg1-1.png
// module id = 720
// module chunks = 0